import { createAsyncThunk } from '@reduxjs/toolkit';
import { ClaimResponseDeadlineExtensionDTO, ClaimsApi } from '@reposit/api-client';
import { AxiosResponse } from 'axios';
import { AppState } from '../root.reducer';
import { createStandardClaimsApi, runThunkWithAuth } from '../utils/api.utils';
import { FetchClaimResponseDeadlineExtensionsPayload } from './claim-response-deadline-extensions.types';

export const fetchClaimResponseDeadlineExtensionsThunk = createAsyncThunk<
  ClaimResponseDeadlineExtensionDTO[],
  FetchClaimResponseDeadlineExtensionsPayload,
  { state: AppState }
>('claim-response-deadline-extensions/fetch-by-claim', async (payload, thunkAPI) => {
  const api: ClaimsApi = createStandardClaimsApi(thunkAPI.getState(), thunkAPI.dispatch);
  const apiResponse: AxiosResponse<ClaimResponseDeadlineExtensionDTO[]> = await runThunkWithAuth(
    () => api.getClaimResponseDeadlineExtensions(payload.claimId),
    thunkAPI.dispatch,
  );
  return apiResponse.data;
});
